<template>
    <table class="calender_table" id="calendar-app">
        <tbody>
            <tr>
                <th class="sunday">日</th>
                <th>月</th>
                <th>火</th>
                <th>水</th>
                <th>木</th>
                <th>金</th>
                <th class="saturday">土</th>
            </tr>
            <tr v-for="(weekValueList, weekKey) in weekList" :key="weekKey">
                <template v-for="(day, dayKey) in dayCountList" :key="dayKey">
                    <td v-if="weekValueList.dayList[day]" :class="{'cheapest': apiResultList[dayUrlList[weekValueList.dayList[day].linkDateString]] == bestPrice.toLocaleString() + '円', 'sunday': day == 0,'saturday': day == 6, 'assign_day': !currentDate.searchDate.isMonth && currentDate.searchDate.currentDate == weekValueList.dayList[day].targetDate}">
                        <calendar-day-component
                            :month_link=monthLink
                            :target_date=weekValueList.dayList[day]
                            :api_result_list=apiResultList
                            v-on:apiResultList="apiResultList[$event] = '読込中'; dayUrlList[weekValueList.dayList[day].linkDateString] = $event;"
                        />
                    </td>
                    <td v-else :class="{'sunday': day == 0,'saturday': day == 6}"></td>
                </template>
            </tr>
        </tbody>
    </table>
</template>

<script>
    import { ref, reactive, onMounted } from 'vue'
    export default ({
        props: {
            // 引数の受け問
            week_list : {type: String, require: true},
            month_link : {type: String, require: true},
            current_date: {type: String, require: true},
        },
        setup (props) {
            let dayCountList = [0,1,2,3,4,5,6]
            let weekList = JSON.parse(props.week_list)
            let monthLink = JSON.parse(props.month_link)
            let currentDate = JSON.parse(props.current_date)

            // 設定用の変数
            const apiResultList = reactive({})
            const dayUrlList = reactive({})
            const bestPrice = ref(99999999999)

            // 完了時
            onMounted(() => {
                let urlList = []
                Object.keys(apiResultList).forEach(function (url) {
                    urlList.push(url)
                })

                if(urlList.length == 0) {
                    return;
                }

                axios.post("/api/bestPrice/", {
                    urlList: urlList,
                })
                .then(function (response) {
                    Object.keys(response.data.bestPriceList).forEach(function (url) {
                        if(response.data.bestPriceList[url]) {
                            apiResultList[url] = response.data.bestPriceList[url].price.toLocaleString() + "円"

                            if (bestPrice.value > response.data.bestPriceList[url].price) {
                                bestPrice.value = response.data.bestPriceList[url].price
                            }
                        } else {
                            apiResultList[url] = "-"
                        }
                    })
                })
            })

            return {
                dayCountList,
                weekList,
                monthLink,
                currentDate,
                dayUrlList,
                apiResultList,
                bestPrice,
            }
        },
    })
</script>